import { Fragment, FunctionComponent, ReactNode } from 'react';
import { Point, PrintArea, Size } from '@/types';
import { getHasSoftBoundary } from '@/model/printArea/getHasSoftBoundary';

interface Props {
  children: ReactNode;
  printArea: PrintArea;
  cid: number;
  rotation: number;
  offset: Point;
  size: Size;
}

export const SoftBoundary: FunctionComponent<Props> = ({
  printArea: { boundary },
  cid,
  children,
  rotation,
  size,
  offset,
}) => {
  if (getHasSoftBoundary(boundary)) {
    return (
      <g clipPath={`url(#c${cid})`}>
        <clipPath
          id={`c${cid}`}
          clipRule="evenodd"
          transform={`rotate(${-rotation}, ${size.width / 2}, ${
            size.height / 2
          }) translate(${-offset.x}, ${-offset.y})`}
        >
          <path d={boundary.soft.content.svg.path.d} />
        </clipPath>
        {children}
      </g>
    );
  }

  return <Fragment>{children}</Fragment>;
};
